import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import startCase from 'lodash/startCase';
import { withRouter } from 'react-router-dom';

import Step from '~/common/components/Stepper/components/Step';

import {
    FLOW_STEP_BILLING, FLOW_STEP_NUMBERS, FLOW_STEP_PLANS,
    PATH_NUMBERS, PATH_PLANS, PATH_BILLING, PATH_TRIAL_NUMBERS, PATH_TRIAL_SIGNUP,
    PATH_NUMBER_PICKER
} from '~/common/utils/consts.js';

// Import Local Styles
import styles from './stepper.css';

@withRouter
@inject('lockNumberStore', 'offerSuiteStore', 'progressStore', 'trialSignupStore')
@observer
export default class Stepper extends Component {
    renderFirstStep() {
        // destructor props into local variables
        const { currentStep, progressStore, trialSignupStore, history } = this.props;
        const { isTrialFlow } = trialSignupStore;

        // if on trial flow, and not the plans page (occurs when on the user is on trial and gets redirected to plans first from upgrade modal
        // the user does not get switch to direct buy until after the pick a plan ) don't render this step
        if (isTrialFlow && history.location.pathname !== PATH_PLANS) return null;

        const isFlowPlansFirst = progressStore.firstView === FLOW_STEP_PLANS;
        const firstStep = isFlowPlansFirst ? FLOW_STEP_PLANS : FLOW_STEP_NUMBERS;
        const stepToPath = isFlowPlansFirst ? PATH_PLANS : this.IS_NUMBER_PICKING_TEST ? PATH_NUMBER_PICKER : PATH_NUMBERS;
        const stepText = `Pick a ${startCase(firstStep.slice(0, -1))}`;

        return (
            <Step
                isCurrentStep={currentStep === firstStep}
                isEnabled={currentStep !== firstStep}
                to={stepToPath}
            >
                {stepText}
            </Step>
        );
    }

    renderSecondStep() {
        const { currentStep, lockNumberStore, offerSuiteStore, trialSignupStore, progressStore } = this.props;
        const { isTrialFlow } = trialSignupStore;

        const isFlowPlansFirst = progressStore.firstView === FLOW_STEP_PLANS;

        const secondStep = isFlowPlansFirst ? FLOW_STEP_NUMBERS : FLOW_STEP_PLANS;

        const isStepEnabled = isTrialFlow ||
            isFlowPlansFirst ?
            (lockNumberStore.numberIsSelected && lockNumberStore.numberIsLocked)
            :
            !!offerSuiteStore.selectedOfferId;

        const stepToPath = isFlowPlansFirst ?
            isTrialFlow ?
                PATH_TRIAL_NUMBERS
                :
                PATH_NUMBERS
            :
            PATH_PLANS;

        const stepText = `Pick a ${startCase(secondStep.slice(0, -1))}`;

        return (
            <Step
                isCurrentStep={currentStep === secondStep}
                isEnabled={isStepEnabled}
                to={stepToPath}
            >
                {stepText}
            </Step>
        );
    }

    renderThirdStep() {
        // destructor props into local variables
        const { currentStep, lockNumberStore, offerSuiteStore, trialSignupStore } = this.props;
        const { isTrialFlow } = trialSignupStore;

        const isStepEnabled = currentStep !== FLOW_STEP_BILLING && // flow must be elsewhere
            lockNumberStore.numberIsSelected && // number must be selected
            lockNumberStore.numberIsLocked && // number must be locked
            (isTrialFlow || !!offerSuiteStore.selectedOfferId); // if no trial, then a plan must be selected

        const stepToPath = isTrialFlow ? PATH_TRIAL_SIGNUP : PATH_BILLING;
        const stepText = isTrialFlow ? 'Register' : 'Checkout';

        return (
            <Step
                isCurrentStep={currentStep === FLOW_STEP_BILLING}
                isEnabled={isStepEnabled}
                to={stepToPath}
            >
                {stepText}
            </Step>
        );
    }


    render() {
        const { modifiers } = this.props;
        const classList = `${styles.wrapper} ${modifiers || ''}`;
        return (
            <nav className={classList} id="stepper">
                {this.renderFirstStep()}
                {this.renderSecondStep()}
                {this.renderThirdStep()}
            </nav>
        );
    }
}
